/**
 * The controls an institution letter's body may actually carry, as a TinyMCE
 * toolbar spec.
 *
 * A letter body is rendered into the firm's own Word precedent through a CLOSED
 * markup vocabulary, declared and enforced backend-side in
 * `backend/src/correspondences/letter-body/letter-body-vocabulary.ts`. `strong`,
 * `ul`, `ol` and `li` are in it; `em`, `h1`, `h2` and `blockquote` are not, so
 * the editor's default toolbar offers four controls whose output the renderer
 * cannot express. Before VALE-1117 they made the letter fail to render at all;
 * since VALE-1117 `sanitiseLetterBodyHtml` and the mapper unwrap them instead,
 * which is safe but silent, so a lawyer applying italic sees italic on screen
 * and posts a letter without it.
 *
 * It lives here, in its own module rather than beside either editor, because
 * there is more than one letter-body editor and narrowing only one of them is
 * indistinguishable from fixing the problem. Both bind to this constant:
 * `LetterBodyEditor` (the Discovery and Redemption drawer) and
 * `PDFLetterEditor` (the notifications, collection-request and follow-up
 * workflows). `__tests__/letter-body-editor-toolbar-vocabulary.test.ts` derives
 * that membership from the import graph and reconciles every control offered
 * here against the backend vocabulary, so a third editor on this path fails the
 * build rather than shipping on the default toolbar.
 *
 * Deliberately NOT re-exported from `./index`: that barrel pulls in the TinyMCE
 * component, and both call sites load it through a `ssr: false` dynamic import.
 * Import this module directly.
 *
 * Keep it reconciled with the vocabulary: a control added here must map to a tag
 * the mapper emits.
 */
export const LETTER_BODY_TOOLBAR = 'bold | bullist numlist';
